<!-- Footer -->
<footer class="page-footer font-small special-color-dark pt-4">

    <!-- Footer Elements -->
    <div class="container">

        <!-- Social buttons -->
        <ul class="list-unstyled list-inline text-center">
            <li class="list-inline-item">
                <a class="btn-floating btn-fb mx-1" href="https://wa.me/+918524865763">
                    <i class="fab fa-whatsapp"> </i>
                </a>
            </li>
            <li class="list-inline-item">
                <a class="btn-floating btn-tw mx-1" href="https://github.com/mohamedhasimofficial">
                    <i class="fab fa-github"> </i>
                </a>
            </li>
            <li class="list-inline-item">
                <a class="btn-floating btn-li mx-1" href="https://www.linkedin.com/in/mohamedhasim-k/">
                    <i class="fab fa-linkedin-in"> </i>
                </a>
            </li>
            <li class="list-inline-item">
                <a class="btn-floating btn-dribbble mx-1" href="https://mohamedhasimofficial.github.io">
                    <i class="fab fa-dribbble"></i>
                </a>
            </li>
        </ul>
        <!-- Social buttons -->

    </div>
    <!-- Footer Elements -->

    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">© {{currentYear}} Copyright:
        <a href="https://mohamedhasimofficial.github.io"> Developer <mark><strong>K.MOHAMED HASIM</strong></mark> </a>
    </div>
    <!-- Copyright -->

</footer>
<!-- Footer -->